import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=34c091de&"
import script from "./FooterLinks.vue?vue&type=script&lang=js&"
export * from "./FooterLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\cdmgtri\\niem-mapping-app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c091de')) {
      api.createRecord('34c091de', component.options)
    } else {
      api.reload('34c091de', component.options)
    }
    module.hot.accept("./FooterLinks.vue?vue&type=template&id=34c091de&", function () {
      api.rerender('34c091de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterLinks.vue"
export default component.exports